<template>
	<section>
		<div class="hero-slider swiper-container">
			<div class="swiper-wrapper">
				<div v-for="slide in slides" class="swiper-slide">
					<component :is="slide"></component>
				</div>
			</div>
			<div class="swiper-button-prev swiper-button-white"></div>
			<div class="swiper-button-next swiper-button-white"></div>
		</div>
	</section>
</template>

<script>
import AuditCommitteePosting2024 from './AuditCommitteePosting2024.vue';
import KindergartenRegistration2024 from './KindergartenRegistration2024.vue';
import DACOpenHouse2023Vue from './DACOpenHouse2023.vue';
import DACRegistration from './DACRegistration.vue';
import FrenchImmersion2023 from "./FrenchImmersion2023.vue"
import RedefineExcellence2023 from "./RedefineExcellence2023.vue";
import MentalHealthWorkshops from "./MentalHealthWorkshops.vue";
import MentalHealthLiteracy from "./MentalHealthLiteracy.vue";
import DSBNGenericBanner from "./DSBNGenericBanner.vue";
import InclementWeather from "./InclementWeather.vue";


/*
	Slide Structure
	{
			COMPONENT_ABOVE, // NOT A STRING
			start_date: null or new Date( 2022,0,1 ),
			end_date: null or new Date( 2022,0,1 ),
			active: true or false
	},
*/


const slideshow = [
	{
		AuditCommitteePosting2024,
		start_date: new Date(2024, 0, 16, 0, 0, 0),
		end_date: new Date(2024, 0, 31, 0, 0, 0),
		active: true,
	},
	{
		KindergartenRegistration2024,
		start_date: new Date(2024, 1, 2, 0, 0, 0),
		end_date: new Date(2024, 2, 1, 0, 0, 0),
		active: true,
	},
	{
		MentalHealthLiteracy,
		start_date: new Date(2024, 1, 2, 0, 0, 0),
		end_date: new Date(2024, 5, 1, 0, 0, 0),
		active: true,
	},
	{
		DACOpenHouse2023Vue,
		start_date: new Date(2024, 0, 10),
		end_date: new Date(2024, 1, 7, 10, 0, 0),
		active: true,
	},
	{
		DACRegistration,
		start_date: new Date(2024, 1, 7, 12, 0, 0),
		end_date: new Date(2024, 1, 27, 0, 0, 0),
		active: true,
	},
	{
		FrenchImmersion2023,
		start_date: new Date(2024, 0, 8, 12, 0, 0), // set to go up Jan 8 at 12pm
		end_date: new Date(2024, 1, 21),
		active: true,
	},
	{
		RedefineExcellence2023,
		start_date: new Date(2023, 9, 24),
		end_date: null,
		active: true,
	},
	{
		MentalHealthWorkshops,
		start_date: new Date(2023, 9, 29),
		end_date: null,
		active: true,
	},
	{
		DSBNGenericBanner,
		start_date: null,
		end_date: null,
		active: true,
	},
	{
		InclementWeather,
		start_date: null,
		end_date: null,
		active: false,
	},
];
const today = new Date();
const todaysDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

const slides = {};
slideshow.forEach((slide) => {
	if (slide.active && (slide.start_date == null || slide.start_date <= today) && (slide.end_date == null || slide.end_date >= today)) {
		// get the name of the component through this simple trick (doctors hate it),
		const keys = Object.keys(slide);
		slides[keys[0]] = slide[keys[0]];
	}
});

export default {
	name: "Bananar",
	components: slides,
	data() {
		return {
			slides,
		};
	},
};
</script>

<style lang="less">
@import "../_base/styles/variables.less";
@import "../../node_modules/swiper/dist/css/swiper.css";

code {
	white-space: normal !important;
}

.swiper-button-white {
	background: rgba(0, 0, 0, 0.4);
	transition: ease all 400ms;
	background-size: 50%;
	background-repeat: no-repeat;
	background-position: center center;
	width: 37px;
	height: 50px;
	&:hover {
		transform: scale(1.1);
	}
}
.swiper-button-prev {
	left: 0px;
	@media (min-width: 1500px) {
		left: 10px;
	}
}
.swiper-button-next {
	right: 0px;
	@media (min-width: 1500px) {
		right: 10px;
	}
}
.hero {
	z-index: 1;
	position: relative;
	overflow: hidden;
	min-height: none;
	max-height: none;
	height: 80vh;
	font-size: 12pt;

	a.outline-button {
		font-size: 1.5em;
		line-height: 1.2;
		color: white;
		display: inline-block;
		padding: 0.25em 0.5em;
		border: 1px solid white;
	}

	@media (min-width: @nav-width-break) {
		min-height: 600px;
		max-height: 850px;
		height: 90vh;
	}

	&:before {
		content: "";
		background: black;
		width: 100%;
		height: 200px;
		position: absolute;
		background: rgba(0, 0, 0, 0.4);
		/* For browsers that do not support gradients */
		background: -webkit-linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
		/* For Safari 5.1 to 6.0 */
		background: -o-linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
		/* For Opera 11.1 to 12.0 */
		background: -moz-linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
		/* For Firefox 3.6 to 15 */
		background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
		/* Standard syntax */
		z-index: 2;
		left: 0;
		top: 0;
	}

	.background {
		z-index: 1;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;

		img {
			min-width: 100%;
			min-height: 100%;
			max-width: none;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
		}
	}

	.content {
		z-index: 3;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		display: flex;
		align-items: center;

		.w-m-50 {
			@media (min-width: @nav-width-break) {
				width: 50%;
			}
		}

		&.content-bottom {
			align-items: flex-end;
			bottom: 15%;
		}

		&.content-centered {
			text-align: center;

			h1 {
				margin-left: auto;
				margin-right: auto;
			}
		}

		&.content-right {
			text-align: right;

			h1 {
				margin-left: auto;
			}
		}
	}

	h1,
	h2 {
		text-shadow: 0 0 18px rgba(0, 0, 0, 0.59);
		font-weight: bold;
		margin: 2rem 0;
	}
	h1 {
		font-family: @font-hero;
		color: #fff;
		font-size: 7rem;
	}
	h2 {
		font-size: 3rem;
	}
	.text-xxl {
		font-size: calc(12pt * 4); // 3 x base
		line-height: 1em;
	}
	.text-xl {
		font-size: calc(12pt * 3); // 3 x base
		line-height: 1em;
	}
	.text-l {
		font-size: calc(12pt * 2); // 2x base
		line-height: 1em;
	}
	.text-m {
		font-size: calc(12pt * 1.4); // .3x
		line-height: 1em;
	}
	.text-s {
		font-size: calc(12pt * 0.8);
		line-height: 1em;
	}

	@media (min-width: 768px) {
		.text-xxl {
			font-size: calc(1.2 * 12pt * 4);
		}
		.text-xl {
			font-size: calc(1.2 * 12pt * 3);
		}
		.text-l {
			font-size: calc(1.2 * 12pt * 2);
		}
		.text-m {
			font-size: calc(1.2 * 12pt * 1.4);
		}
		.text-s {
			font-size: calc(1.2 * 12pt * 0.8);
		}
	}
	@media (min-width: 1024px) {
		.text-xxl {
			font-size: calc(1.2 * 12pt * 4);
		}
		.text-xl {
			font-size: calc(1.4 * 12pt * 3);
		}
		.text-l {
			font-size: calc(1.4 * 12pt * 2);
		}
		.text-m {
			font-size: calc(1.4 * 12pt * 1.4);
		}
		.text-s {
			font-size: calc(1.4 * 12pt * 0.8);
		}
	}
	@media (min-width: 1300px) {
		.text-xxl {
			font-size: calc(1.4 * 12pt * 6);
		}
		.text-xl {
			font-size: calc(1.4 * 12pt * 4);
		}
		.text-l {
			font-size: calc(1.4 * 12pt * 2);
		}
		.text-m {
			font-size: calc(1.4 * 12pt * 1.3);
		}
		.text-s {
			font-size: calc(1.4 * 12pt * 0.8);
		}
	}

	.hero-button {
		background: #fff;
		color: #000;
		font-size: 1.2rem;
		box-shadow: 0 0 18px rgba(0, 0, 0, 0.59);
		padding: 0 20px;
		position: relative;
		height: 40px;
		line-height: 40px;
		@media (min-width: @nav-width-break) {
			margin-left: 40px;
		}

		.icon {
			position: absolute;
			left: -40px;
			border: 3px solid #fff;
			display: block;
			width: 40px;
			height: 34px;
			display: none;
			box-shadow: -10px 0 18px rgba(0, 0, 0, 0.3);
			@media (min-width: @nav-width-break) {
				display: block;
			}

			.arrow-right {
				position: absolute;
				top: 8px;
				left: 18px;
				border-left-color: #fff;

				&:before {
					border-top-color: #fff;
				}
			}
		}

		&:hover {
			background: @color-brand;
			color: #fff;

			.icon {
				border-color: @color-brand;
			}
		}
	}
}

/* animations */
.hero {
	.animate {
		transition: ease all 2000ms;
	}
	.fade-in {
		opacity: 0;
	}
	.slide-up {
		transform: translateY(60px);
	}
	.slide-down {
		transform: translateY(-60px);
	}
	.slide-left {
		transform: translateX(-60px);
	}
	.slide-right {
		transform: translateX(60px);
	}

	/* animation delays*/
	.delay-200 {
		transition-delay: 200ms;
	}
	.delay-400 {
		transition-delay: 400ms;
	}
	.delay-600 {
		transition-delay: 600ms;
	}
	.delay-800 {
		transition-delay: 800ms;
	}
	.delay-1000 {
		transition-delay: 1000ms;
	}

	.delay-1200 {
		transition-delay: 1200ms;
	}
	.delay-1400 {
		transition-delay: 1400ms;
	}
	.delay-1600 {
		transition-delay: 1600ms;
	}
	.delay-1800 {
		transition-delay: 1800ms;
	}
	.delay-2000 {
		transition-delay: 2000ms;
	}

	.delay-2200 {
		transition-delay: 2200ms;
	}
	.delay-2400 {
		transition-delay: 2400ms;
	}
	.delay-2600 {
		transition-delay: 2600ms;
	}
	.delay-2800 {
		transition-delay: 2800ms;
	}
	.delay-3000 {
		transition-delay: 3000ms;
	}

	.delay-3200 {
		transition-delay: 3200ms;
	}
	.delay-3400 {
		transition-delay: 3400ms;
	}
	.delay-3600 {
		transition-delay: 3600ms;
	}
	.delay-3800 {
		transition-delay: 3800ms;
	}
	.delay-4000 {
		transition-delay: 4000ms;
	}

	/* animation delays*/
	.duration-200 {
		transition-duration: 200ms;
	}
	.duration-400 {
		transition-duration: 400ms;
	}
	.duration-600 {
		transition-duration: 600ms;
	}
	.duration-800 {
		transition-duration: 800ms;
	}
	.duration-1000 {
		transition-duration: 1000ms;
	}

	.duration-1200 {
		transition-duration: 1200ms;
	}
	.duration-1400 {
		transition-duration: 1400ms;
	}
	.duration-1600 {
		transition-duration: 1600ms;
	}
	.duration-1800 {
		transition-duration: 1800ms;
	}
	.duration-2000 {
		transition-duration: 2000ms;
	}

	.duration-2200 {
		transition-duration: 2200ms;
	}
	.duration-2400 {
		transition-duration: 2400ms;
	}
	.duration-2600 {
		transition-duration: 2600ms;
	}
	.duration-2800 {
		transition-duration: 2800ms;
	}
	.duration-3000 {
		transition-duration: 3000ms;
	}

	.duration-3200 {
		transition-duration: 3200ms;
	}
	.duration-3400 {
		transition-duration: 3400ms;
	}
	.duration-3600 {
		transition-duration: 3600ms;
	}
	.duration-3800 {
		transition-duration: 3800ms;
	}
	.duration-4000 {
		transition-duration: 4000ms;
	}
}
.swiper-slide-active {
	.hero {
		.fade-in {
			opacity: 1;
		}
		.slide-up,
		.slide-down {
			transform: translateY(0);
		}
		.slide-left,
		.slide-right {
			transform: translateX(0);
		}
	}
}
.flex {
	display: flex;
}
.flex--align-center {
	align-items: center;
}
.flex--justify-center {
	justify-content: center;
}
.flex--justify-end {
	justify-content: flex-end;
}
.flex--column {
	flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// theme/bananar/Bananar.vue